var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'content-boxes',
    _vm.dimensions.width > 600 ? 'py-xl' : 'pt-2xl pb-l',
    _vm.css
  ]},_vm._l((_vm.children),function(item){return _c('a',{key:item.title,staticClass:"content-boxes--item text-left text-gray-7",class:[_vm.properties.bg || 'bg-gray-1'],attrs:{"href":item.url}},[_c('div',{staticClass:"content-boxes--item--image",style:(_vm.imageStyle(item))}),_c('div',{staticClass:"content-boxes--item--content",class:[
        _vm.dimensions.width > 1024 ? 'p-l' : 'p-m',
        _vm.properties.centerLabel ? 'text-center' : ''
      ]},[_c('h4',{staticClass:"font-rg",class:[
          _vm.properties.titleColor || 'text-gray-8',
          _vm.properties.titleSize || ''
        ],domProps:{"textContent":_vm._s(item.title)}}),(item.sub_title)?_c('p',{staticClass:"summary",class:[
          _vm.properties.textColor || 'text-gray-8',
          _vm.properties.textSize || ''
        ],domProps:{"textContent":_vm._s(item.sub_title)}}):_vm._e()])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }